import React from 'react'
import { productService } from '@cabukaka/services';
import { Product } from '@cabukaka/types';
import useDataById from '../core/useDataById';

export  function useProduct({ id }: { id: string }) {
    const {
        data: product,
        loading,
        error,
        deleteItem,
        updateItem
    } = useDataById<Product>({ service: {
        ...productService,
        ...productService.baseService
    }, id });

    return {
     product,
     error,
     loading,
     deleteProduct: deleteItem,
     updateProduct: updateItem,
    }

}
